export default (state = [], action) => {
    switch (action.type) {
       
            case 'FETCH_PERIODS_Number':
                return action.payload;
        default:
            return state;
    }
};
